import axios from 'axios'
export default {
    namespaced: true,
    state: {
		endpoint: '/vehicle/category/brand',
        items: [],
    },
    actions: {
		load (context, param) {
			//console.log('VehicleBrand', 'load','param', param)

			return axios.get(`/vehicle/category/${param.category.id}/brand`).then(response => {
				//console.log(this.$options.name, 'onSearch','response.data', response.data)
				context.commit('items', response.data)
			}, error => {
				console.log(error)
			})
		},
    }
}